import { render } from "./DangerTriangleIcon.vue?vue&type=template&id=945a1654"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/DangerTriangleIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "945a1654"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('945a1654', __exports__)) {
    api.reload('945a1654', __exports__)
  }
  
  module.hot.accept("./DangerTriangleIcon.vue?vue&type=template&id=945a1654", () => {
    api.rerender('945a1654', render)
  })

}


export default __exports__